// extracted by mini-css-extract-plugin
export var container = "_9s-0";
export var error = "_9s-9";
export var label = "_9s-5";
export var light = "_9s-6";
export var md = "_9s-3";
export var sm = "_9s-2";
export var thin = "_9s-8";
export var thinBold = "_9s-7";
export var vertical = "_9s-4";
export var xs = "_9s-1";